// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgh_a bhe_bi"};